import axios from "axios";
import Session from "redux/classes/Session";
import { requestFailure, sendError } from "redux/slices/app";
import { AppDispatch, RootState } from "redux/store";

// Lambdas that require the actor's identity for mutation. Reads still get
// their userID from the auth token; admin "view as" mode appends the
// viewAsUserID query so the backend can override the read scope. Mutation
// lambdas reject the field server-side.
export function CallLambda(session: Session, lambda: string, payload: any) {
    const buildResponse = (status: number, data: any) => {
        return {
            status: status,
            data: data
        }
    }

    const handleError = (dispatch: AppDispatch, error: any) => {
        console.log(error);
        dispatch(requestFailure());
        dispatch(sendError({ message: "API Error - " + lambda }));
        return buildResponse(400, error)
    }

    return async (dispatch: AppDispatch, getState: () => RootState) => {
        try {
            const invoke_url = `${session.apiBaseUrl}/${lambda}`;
            const headers = {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${session.accessToken}`,
                    'Accept': 'application/json'
                }
            }

            // If the console is in admin "view as" mode, attach viewAsUserID to
            // every payload. The backend's read endpoints honor it (only when
            // the actor is an admin); mutation endpoints reject it server-side
            // as an extra defense behind the UI's disabled buttons.
            const adminViewUserID = getState?.().user?.adminViewUserID;
            let outgoingPayload = payload;
            if (adminViewUserID) {
                if (typeof payload === "string") {
                    try {
                        const parsed = JSON.parse(payload);
                        parsed.viewAsUserID = adminViewUserID;
                        outgoingPayload = JSON.stringify(parsed);
                    } catch {
                        // payload is a raw string we don't own — leave alone.
                    }
                } else if (payload && typeof payload === "object") {
                    outgoingPayload = { ...payload, viewAsUserID: adminViewUserID };
                }
            }

            const response = await axios.post(invoke_url, outgoingPayload, headers);

            if (response.status === 200) {
                return buildResponse(200, response.data);
            }
            else {
                return handleError(dispatch, response.data.error);
            }
        }
        catch (error) {
            return handleError(dispatch, error);
        }
    }
}